import { PATHS, METHOD } from 'adapters/constants';
import { fileApiService } from 'adapters/fileApiService';
import { HeaderData } from 'adapters/types';
import {
  ArchiveDataRequestPayloadType,
  ArchiveDataResponseType
} from 'components/ExportOrArchiveDialog/types';

export const postArchiveData = async (
  headers: HeaderData,
  storeId: string,
  companyId: string,
  reqObjectAsStreamData: ArchiveDataRequestPayloadType,
  fileExtension: string,
  paymentMethod: string
): Promise<ArchiveDataResponseType> => {
  const response = await fileApiService({
    url: PATHS.getArchiveUrlPath(companyId, fileExtension, paymentMethod),
    method: METHOD.POST,
    headers: {
      ...headers,
      'x-store-id': storeId
    },
    reqObjectAsStreamData
  });
  if (!response?.ok) throw new Error(response.statusText);
  return response.json() as Promise<ArchiveDataResponseType>;
};
